import { OnChanges, SimpleChanges, } from '@angular/core';
import { SpinnerColor, SpinnerSize } from '@freelancer/ui/spinner';
export var ButtonColor;
(function (ButtonColor) {
    ButtonColor["SECONDARY"] = "secondary";
    ButtonColor["DEFAULT"] = "default";
    ButtonColor["SUCCESS"] = "success";
    ButtonColor["DANGER"] = "danger";
    ButtonColor["TRANSPARENT_DARK"] = "transparent-dark";
    ButtonColor["TRANSPARENT_LIGHT"] = "transparent-light";
    ButtonColor["PRIMARY"] = "primary";
    ButtonColor["RECRUITER"] = "recruiter";
    ButtonColor["TRANSPARENT_RECRUITER"] = "transparent-recruiter";
    ButtonColor["CUSTOM"] = "custom";
})(ButtonColor || (ButtonColor = {}));
export var ButtonSize;
(function (ButtonSize) {
    ButtonSize["MINI"] = "mini";
    ButtonSize["SMALL"] = "small";
    ButtonSize["LARGE"] = "large";
    ButtonSize["XLARGE"] = "xlarge";
    ButtonSize["XXLARGE"] = "xxlarge";
})(ButtonSize || (ButtonSize = {}));
export var ButtonGroupPosition;
(function (ButtonGroupPosition) {
    ButtonGroupPosition["FIRST"] = "first";
    ButtonGroupPosition["MIDDLE"] = "middle";
    ButtonGroupPosition["LAST"] = "last";
})(ButtonGroupPosition || (ButtonGroupPosition = {}));
var ButtonComponent = /** @class */ (function () {
    function ButtonComponent() {
        this.SpinnerColor = SpinnerColor;
        this.SpinnerSize = SpinnerSize;
        this.buttonGroupFirst = false;
        this.buttonGroupMiddle = false;
        this.buttonGroupLast = false;
        this.display = 'inline';
        this.buttonType = 'button';
        this.rel = '';
        this.allRel = '';
        this.external = false;
    }
    Object.defineProperty(ButtonComponent.prototype, "submit", {
        set: function (value) {
            this.buttonType = value ? 'submit' : 'button';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonComponent.prototype, "disabled", {
        get: function () {
            return !!this.attrDisabled;
        },
        set: function (value) {
            this.attrDisabled = value ? true : undefined;
        },
        enumerable: true,
        configurable: true
    });
    ButtonComponent.prototype.isExternalLink = function (link) {
        // Check if the link is http(s) or protocol relative.
        return !!link && (link.startsWith('http') || link.startsWith('//'));
    };
    ButtonComponent.prototype.ngOnChanges = function (changes) {
        this.spinnerColor =
            this.color === ButtonColor.DEFAULT || ButtonColor.TRANSPARENT_DARK
                ? SpinnerColor.GRAY
                : SpinnerColor.LIGHT;
        if (this.buttonGroupPosition) {
            this.buttonGroupFirst =
                this.buttonGroupPosition === ButtonGroupPosition.FIRST;
            this.buttonGroupMiddle =
                this.buttonGroupPosition === ButtonGroupPosition.MIDDLE;
            this.buttonGroupLast =
                this.buttonGroupPosition === ButtonGroupPosition.LAST;
        }
        if ('link' in changes) {
            // Check if the link is http(s) or protocol relative.
            this.external = this.isExternalLink(this.link);
        }
        if ('link' in changes || 'rel' in changes) {
            // Add noopener to rel if external link, due to security exploits
            // Ref: https://mathiasbynens.github.io/rel-noopener/
            if (this.isExternalLink(this.link) && !this.rel.includes('noopener')) {
                this.allRel = this.rel + " noopener";
            }
            else {
                this.allRel = this.rel;
            }
        }
    };
    return ButtonComponent;
}());
export { ButtonComponent };
